<template>
    <div v-if="loading">
        <LoadingSpinner v-if="loading" />
    </div>

    <ChangeTopicStatusPopup ref="changeTopicStatusPopup" @statusChanged="statusChanged" @statusTopicLinkChanged="statusTopicLinkChanged"></ChangeTopicStatusPopup>
    <div class="naGrid">
        <div class="naHeader">
            <div class="naHead">
                {{pageTitle}}
            </div>
            <div class="naDescription" v-if="quickHelpHasEntry">
                <div v-html="pageDescription"></div>
            </div>
            <div class="naTopControls" v-if="showExpertsModeSwitch">
                <div>{{btn.BtnExpertView}}</div>
                <div>
                    <DxSwitch :element-attr="switchAttributes" v-model:value="expertMode"></DxSwitch>
                </div>
            </div>
        </div>
        <div v-bind:class="readAccessClasses">
            <div class="na-Header">
                <div class="na-Filter">
                    <div v-if="access.allowCart && showBookmarkFilter" class="na-FilterCell">
                        <div class="na-FilterLabel">{{title.BookMarkLists}}</div>
                        <div class="na-FilterBox" :key="CartBoxKey">
                            <DxSelectBox :data-source="cartList"
                                         :search-enabled="true"
                                         :show-clear-button="true"
                                         display-expr="CrtFullName"
                                         v-model:value="selectedCrt">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div v-if="access.allowTopicLink && expertMode && showTopicFilter" class="na-FilterCell">
                        <div class="na-FilterLabel">{{filterTitle}}:</div>
                        <div class="na-FilterBox" :key="filterBoxKey">
                            <DxSelectBox :data-source="filterTopicList"
                                         :search-enabled="true"
                                         :show-clear-button="true"
                                         display-expr="ParsedTitle"
                                         v-model:value="selectedFilter">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="na-FilterCell" v-if="expertMode && showRoundFilter">
                        <div class="na-FilterLabel">Campagne:</div>
                        <div class="na-FilterBox">
                            <DxSelectBox :data-source="roundList"
                                         :search-enabled="true"
                                         :show-clear-button="true"
                                         display-expr="RouName"
                                         value-expr="RouId"
                                         v-model:value="selectedRouId">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="na-FilterCell" v-if="expertMode && showTtySelection">
                        <div class="na-FilterLabel">Topic Type:</div>
                        <div class="na-FilterBox">
                            <DxSelectBox :data-source="topicTypeList"
                                         :search-enabled="true"
                                         :show-clear-button="true"
                                         display-expr="TtyName"
                                         x-value-expr="TtyId"
                                         v-model:value="selectedTty">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="na-FilterCell" v-if="expertMode && showStatusFilter">
                        <div class="na-FilterLabel">Status:</div>
                        <div class="na-FilterBox">
                            <DxSelectBox :data-source="statusList"
                                         :search-enabled="true"
                                         :show-clear-button="true"
                                         display-expr="StatusName"
                                         value-expr="StatusID"
                                         v-model:value="selectedStatusId">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="na-FilterCell" v-if="showOwnerStatus">
                        <div class="na-FilterLabel"></div>
                        <div class="na-FilterBox">
                            <DxRadioGroup :items="filterList"
                                          v-model:value="filterValue"
                                          layout="horizontal" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="na-list">
                <DxDataGrid v-model:data-source="topicList"
                            @cell-prepared="onCellPrepared"
                            :ref="gridKey"
                            v-model:selected-row-keys="selectedRowKeys"
                            key-expr="TopicId"
                            @cell-click="viewDetail"
                            @selection-changed="onSelectionChanged"
                            :activeStateEnabled="true"
                            :allow-column-reordering="true"
                            :allowColumnResizing="true"
                            @editorPreparing="onEditorPreparing"
                            @exporting="onExporting"
                            :rowAlternationEnabled="true"
                            columnAutoWidth="true"
                            :show-borders="true"
                            v-model:columns="gridColumns"
                            hoverStateEnabled="true">
                    <DxColumnChooser :enabled="true" :allow-search="true" mode="select" />
                    <DxColumnFixing :enabled="true" />
                    <DxFilterPanel :visible="true" />
                    <DxFilterRow :visible="true" />
                    <DxHeaderFilter :visible="true" />
                    <DxSearchPanel :visible="true" placeholder="Search ..." />
                    <DxLoadPanel :enabled="false" />
                    <DxScrolling row-rendering-mode="standard" />
                    <DxPaging :page-size="15" />
                    <DxPager :visible="true"
                             :allowed-page-sizes="pageSizes"
                             :display-mode="full"
                             :show-page-size-selector="true"
                             :show-info="true"
                             :show-navigation-buttons="true" />
                    <DxSorting mode="multiple" />
                    <DxGroupPanel :visible="true" />
                    <DxStateStoring :enabled="true"
                                    type="sessionStorage"
                                    :storage-key="filterKey" />
                    <DxExport :enabled="true"
                              :icon="toolbar.export"
                              :allow-export-selected-data="true" />

                    <DxSelection :mode="selectionMode" select-all-mode="allPages" allow-select-all="true" />
                    <DxToolbar>
                        <DxItem name="groupPanel" />
                        <DxItem template="bulkActions" />
                        <DxItem name="searchPanel" />
                        <!--<DxItem name="fullTextSearchPanel">
                            <div class="fullTextFilterBox">
                                <DxTextBox v-model:value="searchText" :showClearButton="true" @enterKey="search" @keyDown="searchChanged" @valueChanged="searchValueChanged" />
                                <div v-if="searchVisible" class="na-search-icon">
                                    <DxButton stylingMode="text" icon="fas fa-search" :hint="tx.SearchHint" @click="search"></DxButton>
                                </div>
                            </div>
                        </DxItem>-->
                        <DxItem>
                            <DxButton :icon="toolbar.add" :hint="btn.btnHintnewTheme" :visible="topicTypeAccess.New && showAddNew" @click="addTopic"></DxButton>
                        </DxItem>
                        <DxItem name="columnChooserButton"></DxItem>
                        <DxItem name="exportButton" cssClass="mnExport" showText="false" />


                        <DxItem>
                            <DxButton :icon="toolbar.clear" :hint="btn.btnHintFilter" @click="resetState"></DxButton>
                        </DxItem>
                        <!--<DxItem>
                            <DxButton icon="fas fa-sync" hint="Filter zurücksetzen" @click="resetFilter"></DxButton>
                        </DxItem>-->
                    </DxToolbar>
                    <template #bulkActions>
                        <div class="pq-toolbar-bulk">
                        <DxButton
                            v-if="accessList._200721 && hasSelection"
                            :text="btn.BtnSendBulkMail"
                            icon="fa-light fa-envelopes-bulk"
                            @click="showSendBulkMail" />
                        <DxButton
                            v-if="hasSelection && accessList._200781"
                            :text="btn.BtnBulkDownload"
                            icon="fa-light fa-envelopes-bulk"
                            @click="showBulkDownload" />
                        </div>
                    </template>
                    <template #percentTemplate="{ data }" class="pq-td-center">
                        {{ Number.parseFloat(data.value * 100).toFixed(0) }} %
                    </template>
                    <template #multi="{ data }">
                        <div class="pq-multi" v-html="SplitMulti(data)"></div>
                    </template>

                    <template #commentTemplate="{ data }">
                        <div class="grdCommentBox" @click="showComments(data)" v-if="accessList._300511">
                            <div class="grdCommentIcon"><i class="fas fa-comments"></i></div>
                            <div class="grdCommentUnreadCountBox">
                                <div class="grdCommentUnreadCount" v-if="data.data.CommentsUnreadCount>0">{{data.data.CommentsUnreadCount}}</div>
                            </div>
                            <div class="grdCommentCount">{{data.value}}</div>
                        </div>
                    </template>
                    <template #plainTemplate="{ data }">
                        {{data.value}}
                    </template>
                    <template #flagTemplate="{ data }">
                        <div class="flgBox" :id="'flagMenu' + data.data.TopicId">
                            <div class="flgBoxIcon">
                                <i v-bind:class="['fa', 'fa-flag', 'FlagMenuItem-' + data.value]"></i>
                            </div>
                            <div class="flgBoxMenu">
                                <DxMenu :data-source="getFlagMenuItems(data)"
                                        items-expr="items"
                                        cssClass="flgBoxMenu"
                                        orientation="horizontal"
                                        :hideSubmenuOnMouseLeave="true"
                                        @item-click="function(e) { flagItemClick(e, data) }"
                                        itemTemplate="itemTemplate"
                                        show-first-submenu-mode="onHover"
                                        show-submenu-mode="onHover">
                                    <template #itemTemplate="{ data }">
                                        <div>
                                            <div class="pq-menu-item">
                                                <i v-bind:class="data.icon"></i>
                                                <div class="pq-menu-txt">{{data.text}}</div>
                                            </div>
                                        </div>
                                    </template>
                                </DxMenu>
                            </div>
                        </div>
                    </template>
                    <template #EndofStudyTemplate="{ data }">
                        <div :class="{ endOfStudy:true}">
                            {{data.text}}
                        </div>

                    </template>
                    <template #actionTemplate="{data }">
                        <div class="pqMenuBtn">
                            <DxButton class="pqBtn" icon="fas fa-eye" @click="viewTopicNr(data.value)"></DxButton>
                            <DxButton v-if="data.data.AllowEdit" class="pqBtn" icon="fas fa-pen" @click="editTopic(data.value)"></DxButton>
                        </div>
                    </template>
                    <template #topicStatusActionTemplate="{ data }">
                        <div>
                            <div class="pqStatusActionList" v-for="item in data.data.TopicActions" :key="item.StatFusId">
                                <div class="pqStatusAction" @click="changeTopicStatus(data.data.TopicId, item.StatusId)">{{ item.ActionButtonText }}</div>
                            </div>
                        </div>
                    </template>
                    <template #topicLinkStatusActionTemplate="{ data }">
                        <div>
                            <div class="pqStatusActionList" v-for="item in data.data.TopicLinkActions" :key="item.StatusId">
                                <div class="pqStatusAction" @click="changeTopicLinkStatus(data.data.TopicId, item.TliId, item.StatusId)">
                                    {{ item.ActionButtonText }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #sfTemplate="{ data }">
                        <div>
                            <span v-html="data.value"></span>
                        </div>
                    </template>
                    <template #htmlTemplate="{ data }">
                        <div>
                            <span class="pqTooltip" v-html="data.value"></span>
                        </div>
                    </template>
                    <template #emailTemplate="{ data }">
                        <div class="pqEmailCol">
                            <a class="pqEmail" :href="'mailto:' + data.value">{{data.value}}</a>
                        </div>
                    </template>
                </DxDataGrid>
            </div>
            <div class="puFooterButtons">
                <div v-if="access.allowChangeState && hasSelection && showStatusFilter">
                    <DxButton :text="btn.BtnChangeStatus" @click="showChangeState"></DxButton>
                </div>
                <!--<div v-if="hasSelection && access.allowChangeCart">
                    <DxButton :text="tx.AddThemaToBL" @click="showAddToCart"></DxButton>
                </div>-->
                <div v-if="hasSelection && access.allowChangeCart && selectedCrt != null">
                    <DxButton :text="tx.RemoveFromBL" @click="showRemoveFromCart"></DxButton>
                </div>
                <div v-if="access.allowChangeCart && selectedCrt != null && selectedCrt.IsOwner == true">
                    <DxButton :text="tx.EditBL" @click="showEditCart"></DxButton>
                </div>
                <div v-if="hasSelection && access.allowChangeTopicLink && showTopicFilter">
                    <DxButton :text="'Add to ' + filterTitle" icon="fal fa-user-plus" @click="showAddToTopic"></DxButton>
                </div>
                <div v-if="hasSelection && access.allowChangeTopicLink && selectedFilter != null && showTopicFilter">
                    <DxButton :text="'Remove from ' + filterTitle" @click="showRemoveFromTopic"></DxButton>
                </div>
            </div>
            <DxPopup v-model:visible="popupVisible" :title="popupTitle" width="auto" height="auto" :content-template="popupTemplate">
                <template #changeStatus>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">New Status</div>
                            <div class="puValue">
                                <DxSelectBox :data-source="newStatusList"
                                             :show-clear-button="false"
                                             display-expr="StatusName"
                                             value-expr="StatusID"
                                             v-model:value="newStatusId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="btn.BtnChangeStatus" @click="changeState" :disabled="!newStatusId>0" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #statusChange>
                    <div class="puChangeState">
                        <div class="puChangeStateMessage" v-html="actionButtonMessage">
                        </div>
                        <div class="puChangeMessage" v-if="hasChangeNotification">
                            <div class="puChangeStateMailTitle">Email Message:</div>
                            <div class="puChangeStateMail">
                                <DxHtmlEditor v-model:value="notificationMessage.Message"
                                              value-type="html"
                                              ref="EmailEditor"
                                              :height="200"
                                              class="html-dx-field">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="assigneeSelection" v-if="showAssigneeSelection">
                            <div class="assigneeSelectionLabel">Select Assignee:</div>
                            <div class="assigneeSelectionValue">
                                <DxSelectBox :data-source="userListForGroup"
                                             :show-clear-button="true"
                                             display-expr="UsrFullName"
                                             value-expr="UsrId"
                                             :search-enabled="true"
                                             :placeholder="tx.ChooseAssignee"
                                             v-model:value="selectedUsrIdForAction">
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="puChangeStateButtons">
                            <div class="puChangeStateButton">
                                <DxButton text="Cancel"
                                          @click="popupChangeStateCancel"
                                          type="default"></DxButton>
                            </div>
                            <div class="puChangeStateButton">
                                <DxButton text="OK"
                                          @click="changeStateOnServer"
                                          type="success"></DxButton>
                            </div>
                        </div>
                    </div>
                </template>
                <template #addToCart>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">
                                {{ title.BookMarkList }}
                            </div>
                            <div class="puValue">
                                <DxSelectBox :data-source="cartList"
                                             :show-clear-button="true"
                                             :accept-custom-value="true"
                                             @custom-item-creating="addingCart"
                                             display-expr="CrtFullName"
                                             width="350"
                                             :placeholder="tx.ChooseNewTopic"
                                             v-model:value="selectedCartForAction">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="tx.AddThemaToBL" @click="addToCart" :disabled="selectedCartForAction == null" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #addToTopic>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">{{ filterTitle }}</div>
                            <div class="puValue">
                                <DxSelectBox :data-source="filterTopicList"
                                             :show-clear-button="true"
                                             :accept-custom-value="true"
                                             @custom-item-creating="addingLinkedTopic"
                                             display-expr="ParsedTitle"
                                             width="350"
                                             :placeholder="tx.ChooseNewTopic"
                                             v-model:value="selectedTopicForAction">
                                </DxSelectBox>
                            </div>
                            <div class="puAddTopicLinkMode">
                                <div class="puAddTopicLinkModLabele">Mode:</div>
                                <div class="puAddTopicLinkModeOptions">
                                    <DxRadioGroup :items="addTopicLinkModeItems"
                                                  displayExpr="text"
                                                  valueExpr="id"
                                                  v-model:value="addTopicLinkMode">
                                    </DxRadioGroup>
                                </div>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="tx.AddThemaToTopic" @click="addToTopic" :disabled="selectedTopicForAction == null" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #bulkMail>
                    <div class="puBox">
                        <div class="puCell puSubject">
                            <div class="puLabel">{{ title.Subject }}</div>
                            <br />
                            <div class="puValue">
                                <DxTextBox width="300" v-model:value="bulkMessage.Subject" />
                            </div>
                        </div>
                        <div class="puCell">
                            <div class="puLabel">{{ title.Message }}</div>
                            <br />
                            <div class="puValue">
                                <DxHtmlEditor class="html-dx-field" ref="bulkMailEditor" v-model:value="bulkMessage.Message" :height="200">
                                    <DxVariables :data-source="editorVariables"
                                                 :escape-char="escapeCharacters" />
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="variable" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="btn.BtnSendMail" :disabled="!(bulkMessage.Message && bulkMessage.Subject)" @click="sendBulkMail" type="success" />
                            </div>
                        </div>
                    </div>
                </template>

                <template #bulkDownload>
                    <div class="puBox">
                        <div class="puCell puSubject">
                            <div class="puLabel">{{ tx.DownloadMessage }}</div>
                        </div>
                        <div class="puCell">
                            <div class="puLabel">{{ tx.DownloadFormat }}</div>
                            <div class="puValue">
                                <DxRadioGroup :items="downloadFormatItems"
                                              displayExpr="text"
                                              valueExpr="id"
                                              layout="horizontal"
                                              v-model:value="downloadFormat" />
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton v-if="accessList._200781" :text="btn.BtnStartDownload" @click="downloadPDFs" type="success" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #createNewTopicForUser>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">{{ tx.CreateTopicLabel }}:</div>
                            <div class="puValue">
                                <DxSelectBox :data-source="userListForCreate"
                                             :show-clear-button="true"
                                             display-expr="UsrFullName"
                                             value-expr="UsrId"
                                             :search-enabled="true"
                                             width="350"
                                             :placeholder="tx.ChooseApplicant"
                                             v-model:value="selectedUsrIdForAction">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="tx.CreateTopicAction" @click="createNewTopicForUser" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #removeFromCart>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">{{ tx.PopupBookmarkList }}:</div>
                            <div class="puValue">
                                <div>{{ selectedCartName }}</div>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="tx.RemoveTopicFromBL" @click="removeFromCart" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #removeFromTopic>
                    <div class="puBox">
                        <div class="puCell">
                            <div class="puLabel">{{tx.PopupRemoveFromTopic}}:</div>
                            <div class="puValue">
                                <div>{{ selectedTopicTitle }}</div>
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="tx.RemoveTopicsFromTopic" @click="removeFromTopic" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #editCart>
                    <div class="puBox" v-if="selectedCrt">
                        <div class="puCell">
                            <div class="puLabel">{{title.Name}}</div>
                            <div class="puValue">
                                <DxTextBox v-model:value="selectedCrt.CrtName" />
                            </div>
                        </div>
                        <div class="puCell">
                            <div class="puLabel">{{title.Public}}</div>
                            <div class="puValue">
                                <DxCheckBox v-model:value="selectedCrt.CrtPublic" />
                            </div>
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnCancel" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons" v-if="accessList._300681 || selectedCrt.IsOwner">
                                <DxButton :text="btn.BtnDelete" @click="deleteCart" v-if="accessList._300688 || selectedCrt.IsOwner" />
                                <DxButton :text="btn.BtnSave" @click="editCart" />
                            </div>
                        </div>
                    </div>
                </template>
                <template #comments>
                    <div class="puBox puBoxScroll">
                        <DxScrollView direction="vertical"
                                      show-scrollbar="always"
                                      scroll-by-content="true"
                                      scroll-by-thumb="true">
                            <div class="puCell cmtBox">
                                <div v-for="message in commentList" :key="message.ComId" class="cmtRecord">
                                    <div class="cmtHeader">
                                        <div class="cmtDate">
                                            {{   moment(message.ComCreatedOn).format('DD.MM.YYYY hh:mm')  }}:
                                        </div>
                                        <div class="cmtUser">
                                            {{ message.UsrFullName }}
                                        </div>
                                        <DxButton icon="fal fa-trash" styling-mode="text" v-if="message.IsOwner" @click="acceptDelete(message)" />
                                    </div>
                                    <div class="cmtText">{{ message.ComText }}</div>

                                </div>
                            </div>
                        </DxScrollView>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnClose" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="btn.BtnCloseMarked" @click="markCommentAsRead()" v-if="currentTopic.CommentsUnreadCount >0" />
                                <DxButton :text="btn.BtnNewCm" @click="createNewComment()" v-if="accessList._300514" />
                            </div>
                        </div>

                    </div>
                </template>
                <template #newComment>
                    <div class="puBox">
                        <div class="puCell cmtTextBox">
                            <DxTextArea v-model:value="commentText" height="400" width="700" />
                        </div>
                        <div class="puButtons">
                            <div class="puLeftButtons">
                                <DxButton :text="btn.BtnClose" @click="hidePopup" />
                            </div>
                            <div class="puRightButtons">
                                <DxButton :text="btn.BtnSend" @click="saveComment()" v-if="accessList._300514" />
                            </div>
                        </div>
                    </div>
                </template>
            </DxPopup>
        </div>
    </div>
    <DxToast v-model:visible="isToastVisible"
             v-model:message="toastMessage"
             :displayTime="4000"
             maxWidth="80%">
    </DxToast>
</template>
<script>
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import ChangeTopicStatusPopup from "@/views/widgets/ChangeTopicStatusPopup"
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxScrolling,
        DxSorting,
        DxPaging,
        DxPager,
        //DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxToolbar,
        DxItem,
        DxExport,
        DxSelection
    } from 'devextreme-vue/data-grid'
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import DxTextBox from 'devextreme-vue/text-box'
    import DxSelectBox from 'devextreme-vue/select-box'
    import DxRadioGroup from 'devextreme-vue/radio-group'
    import DxButton from 'devextreme-vue/button'
    import DxTextArea from 'devextreme-vue/text-area'
    import DxMenu from "devextreme-vue/menu"
    import DxToast from "devextreme-vue/toast"
    import DxPopup from "devextreme-vue/popup"
    import DxCheckBox from "devextreme-vue/check-box"
    //import * as Enumerable from "linq-es5";
    import DxSwitch from "devextreme-vue/switch"
    import { DxHtmlEditor } from 'devextreme-vue/html-editor'
    import axios from 'axios'
    import moment from 'moment'
    import { alert } from "devextreme/ui/dialog"

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    const gridServiceUri = "WebApi.asmx/api/dataGrid"
    const gridKey = "TopicOverviewGridMain"
    import { nextTick } from 'vue'

    export default {
        name: 'TopicOverview',
        components: {
            DxScrollView,
            LoadingSpinner,
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxScrolling,
            DxSorting,
            DxSelectBox,
            DxRadioGroup,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxHtmlEditor,
            DxGroupPanel,
            DxButton,
            DxToolbar,
            DxItem,
            DxExport,
            DxMenu,
            DxTextBox,
            DxSelection,
            DxPopup,
            DxCheckBox,
            DxSwitch,
            DxTextArea,
            DxToast,
            ChangeTopicStatusPopup,
        },

        data() {

            return {
                loading: false,
                isToastVisible: false,
                toastMessage: "",
                hasChangeNotification: false,
                showAssigneeSelection: false,
                actionBuffer: [],
                currentFilter: null,
                columnsLoaded: false,
                CartBoxKey: 0,
                pageSizes: [10, 15, 30],
                filterBoxKey: 0,
                addTopicLinkMode: 0,
                addTopicLinkModeItems: [{ id: 0, text: 'add to existing links' }, { id: 1, text: 'replace existing links' }],
                notificationMessage: {
                    Message: ""
                },
                bulkMessage: {
                    Message: "",
                    Subject: ""
                },
                actionTopicId: 0,
                actionStatusId: 0,
                expertMode: this.showExpertsModeSwitch ? false : true,
                filterStateInternal: {},
                searchVisible: true,
                currentTopic: null,
                selectedRowKeys: [],
                popupTemplate: '',
                popupVisible: false,
                popupTitle: '',
                commentText: '',
                newCartName: null,
                newTopicName: null,
                filterList: [{ id: 0, text: this.$LanguageProvider.GetResource("All", "CaptionFilter", "All") },
                { id: 1, text: this.$LanguageProvider.GetResource("MyBookMark", "Caption", "Created by me") },
                { id: 2, text: this.$LanguageProvider.GetResource("AssignedToMe", "Caption", "Assigned to me") },
                ],
                filterValue: 0,
                selectedTty: null,
                selectedCrt: null,
                selectedFilter: null,
                selectedCartForAction: null,
                selectedTopicForAction: null,
                selectedUsrIdForAction: null,
                selectedRouId: null,
                selectedStatusId: null,
                newStatusId: null,
                gridKey,
                filter: {},
                pageIndex: 0,
                isLoaded: false,
                isCreatedByVisible: false,
                isCreatedOnVisible: false,
                isChangedByVisible: false,
                isChangedOnVisible: false,
                isStatusNameVisible: true,
                isDescriptionVisible: false,
                isRankVisible: false,
                allowEditRow: true,
                col: {
                    TitleCol: this.$LanguageProvider.GetResource("TitleCol", "Caption", "Title"),
                    SuchfeldCol: this.$LanguageProvider.GetResource("SuchfeldCol", "Caption", "Search Field"),
                    SuchfelderCol: this.$LanguageProvider.GetResource("SuchfelderCol", "Caption", "Search Fields"),
                    OwnerFirstNameCol: this.$LanguageProvider.GetResource("OwnerFirstNameCol", "Caption", "First Name"),
                    OwnerLastNameCol: this.$LanguageProvider.GetResource("OwnerLastNameCol", "Caption", "Last Name"),
                    SalCaptionENCol: this.$LanguageProvider.GetResource("SalCaptionENCol", "Caption", "Gender"),
                    CityCol: this.$LanguageProvider.GetResource("CityCol", "Caption", "City"),
                    OwnerEmailCol: this.$LanguageProvider.GetResource("OwnerEmailCol", "Caption", "Email"),
                    OwnerTelefonCol: this.$LanguageProvider.GetResource("OwnerTelefonCol", "Caption", "Telephone"),
                    /*    TdgText001Col: this.$LanguageProvider.GetResource("TdgText001Col", "Caption", "Uni/Research Center"),*/
                    TdgText002Col: this.$LanguageProvider.GetResource("TdgText002Col", "Caption", "Uni/Research Center"),
                    UsrCompanyCol: this.$LanguageProvider.GetResource("UsrCompany", "Caption", "Organisation/Research Institution/Uni"),
                    TdgText003Col: this.$LanguageProvider.GetResource("TdgText003Col", "Caption", "Official supervisor"),
                    TdgText004Col: this.$LanguageProvider.GetResource("TdgText004Col", "Caption", "Current status"),
                    TdgText005Col: this.$LanguageProvider.GetResource("TdgText005Col", "Caption", "Working title of thesis"),
                    TdgMemo001Col: this.$LanguageProvider.GetResource("TdgMemo001Col", "Caption", "Abstract of Thesis"),
                    LitName001Col: this.$LanguageProvider.GetResource("LitName001Col", "Caption", "Academic Degree"),
                    DescCol: this.$LanguageProvider.GetResource("DescCol", "Caption", "Description"),
                    ThementypCol: this.$LanguageProvider.GetResource("ThementypCol", "Caption", "Type"),
                    PublishDateCol: this.$LanguageProvider.GetResource("PublishDateCol", "Caption", "Publication Date"),
                    TpcBegin: this.$LanguageProvider.GetResource("TpcBegin", "Caption", "Begin"),
                    TpcEnd: this.$LanguageProvider.GetResource("TpcEnd", "Caption", "End"),
                    TpcVisibleBegin: this.$LanguageProvider.GetResource("TpcVisibleBegin", "Caption", "Visible from"),
                    TpcVisibleEnd: this.$LanguageProvider.GetResource("TpcVisibleEnd", "Caption", "Visible up to"),
                    CreatedOnCol: this.$LanguageProvider.GetResource("CreatedOnCol", "Caption", "Created on"),
                    CreatedByCol: this.$LanguageProvider.GetResource("CreatedByCol", "Caption", "Created by"),
                    AiFieldsCol: this.$LanguageProvider.GetResource("AiFieldsCol", "Caption", "AI Fields"),
                    AiField1Col: this.$LanguageProvider.GetResource("AiField1Col", "Caption", "AI Field 1"),
                    AiField2Col: this.$LanguageProvider.GetResource("AiField2Col", "Caption", "AI Field 2"),
                    AiField3Col: this.$LanguageProvider.GetResource("AiField3Col", "Caption", "AI Field 3"),
                    ChangedByCol: this.$LanguageProvider.GetResource("ChangedByCol", "Caption", "Changed by"),
                    ChangedOnCol: this.$LanguageProvider.GetResource("ChangedOnCol", "Caption", "Changed on"),
                    RelevantCol: this.$LanguageProvider.GetResource("RelevantCol", "Caption", "Relevance"),
                    StatusCol: this.$LanguageProvider.GetResource("StatusCol", "Caption", "Status"),
                    StatusActionCol: this.$LanguageProvider.GetResource("StatusActionCol", "Caption", "Status Action"),
                    LinkedtopicStatusCol: this.$LanguageProvider.GetResource("LinkedtopicStatusCol", "Caption", this.filterTitle + " Status"),
                    LinkedtopicStatusActionCol: this.$LanguageProvider.GetResource("LinkedtopicStatusActionCol", "Caption", this.filterTitle + " Action"),
                    TpcFullfillmentPercentCol: this.$LanguageProvider.GetResource("TpcFullfillmentPercentCol", "Caption", "Fullfillment"),
                    EndofStudyCol: this.$LanguageProvider.GetResource("EndofStudy", "Caption", "End of study"),
                    AssigneeCol: this.$LanguageProvider.GetResource("AssigneeCol", "Caption", "Assignee"),
                    OwnerCol: this.$LanguageProvider.GetResource("OwnerCol", "Caption", "Owner"),
                },
                btn: {
                    BtnHintnewTheme: this.$LanguageProvider.GetResource("BtnHintnewTheme", "Caption", "Create new topic"),
                    BtnHintFilter: this.$LanguageProvider.GetResource("BtnHintFilter", "Caption", "Reset View and Filter"),
                    BtnExpertView: this.$LanguageProvider.GetResource("BtnExpertView", "Caption", "Experts View"),
                    ByMeCreated: this.$LanguageProvider.GetResource("ByMeCreated", "Caption", "Created by Me"),
                    BtnSend: this.$LanguageProvider.GetResource("BtnSend", "Caption", "Submit"),
                    BtnSendMail: this.$LanguageProvider.GetResource("BtnSend", "Caption", "Send"),
                    BtnNewCm: this.$LanguageProvider.GetResource("BtnNewCm", "Caption", "New Comment"),
                    BtnClose: this.$LanguageProvider.GetResource("BtnClose", "Caption", "Close"),
                    BtnDelete: this.$LanguageProvider.GetResource("BtnDelete", "Caption", "Delete"),
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Update"),
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Cancel"),
                    BtnStartDownload: this.$LanguageProvider.GetResource("BtnStartDownload", "Caption", "Download Files"),
                    BtnChangeStatus: this.$LanguageProvider.GetResource("BtnChangeStatus", "Caption", "Change Status"),
                    BtnSendBulkMail: this.$LanguageProvider.GetResource("BtnSendBulkMail", "Caption", "Send Bulk Mail"),
                    BtnBulkDownload: this.$LanguageProvider.GetResource("BtnBulkDownload", "Caption", "Bulk Download"),
                    BtnCloseMarked: this.$LanguageProvider.GetResource("BtnCloseMarked", "Caption", "Close and Mark as Read"),
                },
                title: {
                    BookMarkLists: this.$LanguageProvider.GetResource("BookMarkLists", "Caption", "Bookmark List:"),
                    BookMarkList: this.$LanguageProvider.GetResource("BookMarkList", "Caption", "Bookmark List:"),
                    Name: this.$LanguageProvider.GetResource("Name", "Caption", "Name:"),
                    Public: this.$LanguageProvider.GetResource("Public", "Caption", "Public:"),
                    Subject: this.$LanguageProvider.GetResource("Subject", "Caption", "Subject:"),
                    Message: this.$LanguageProvider.GetResource("Message", "Caption", "Message:"),

                },
                tx: {
                    TopicListCaption: this.$LanguageProvider.GetResource("TopicListCaption", "Caption", this.title),
                    ToEvalText: this.$LanguageProvider.GetResource("ToEvalText", "Caption", "The topics assigned to you for evaluation can be found at"),
                    myEvaluation: this.$LanguageProvider.GetResource("myEvaluation", "Caption", "My Reviews"),
                    descriptionTitle: this.$LanguageProvider.GetResource("descriptionTitle", "Caption", "Here you can see all editorially elaborated topics on"),
                    descriptionTextFirstPart: this.$LanguageProvider.GetResource("descriptionTxtThemenListe", "Caption", "In this view you have the possibility to filter the topics by the different columns displayed, create bookmark lists and share or export them with your colleagues."),
                    descriptionTextSecondPart: this.$LanguageProvider.GetResource("descriptionTextSecondPart", "Caption", "You are welcome to create your own topic lists for a better overview by marking the topics and - at the very bottom of the page - going to \"Add to bookmark list\"."),
                    ChooseNewTopic: this.$LanguageProvider.GetResource("ChooseNewTopic", "Caption", "Type name for new ") + this.filterTitle,
                    AddThemaToTopic: this.$LanguageProvider.GetResource("ChooseNewTopic", "Caption", "Add Application to ") + this.filterTitle,
                    AddThemaToBL: this.$LanguageProvider.GetResource("AddThemaToBL", "Caption", "Add to Bookmark List"),
                    RemoveFromBL: this.$LanguageProvider.GetResource("RemoveFromBL", "Caption", "Remove from Bookmark Liste"),
                    RemoveTopicFromBL: this.$LanguageProvider.GetResource("RemoveTopicFromBL", "Caption", "Remove from von Bookmark List"),
                    RemoveTopicsFromTopic: this.$LanguageProvider.GetResource("RemoveTopicsFromTopic", "Caption", "Remove application from ") + this.filterTitle,
                    EditBL: this.$LanguageProvider.GetResource("EditBL", "Caption", "Edit Bookmark List"),
                    SearchHint: this.$LanguageProvider.GetResource("SearchHint", "Caption", "Fulltext Search"),
                    PopupBookmarkList: this.$LanguageProvider.GetResource("PopupBookmarkList", "Caption", "Selectd Bookmark List"),
                    PopupRemoveFromTopic: this.$LanguageProvider.GetResource("PopupRemoveFromTopic", "Caption", "Selected " + this.filterTitle),
                    CreateTopicLabel: this.$LanguageProvider.GetResource("CreateTopicLabel", "Caption", "Selected Applicant"),
                    CreateTopicAction: this.$LanguageProvider.GetResource("CreateTopicAction", "Caption", "Create Application"),
                    ChooseApplicant: this.$LanguageProvider.GetResource("ChooseApplicant", "Caption", "Choose Applicant"),
                    ChooseAssignee: this.$LanguageProvider.GetResource("ChooseAssignee", "Caption", "Choose Assignee"),
                    DownloadMessage: this.$LanguageProvider.GetResource("DownloadMessage", "Caption", "Do you really want to download the files for the selected entries?"),
                    DownloadFormat: this.$LanguageProvider.GetResource("DownloadFormat", "Caption", "Format"),
                },
                // New: format selection for bulk download
                downloadFormat: 'pdf',
                downloadFormatItems: [
                    { id: 'pdf', text: this.$LanguageProvider.GetResource('DownloadFormatPdf', 'Caption', 'PDF') },
                    { id: 'docx', text: this.$LanguageProvider.GetResource('DownloadFormatDocx', 'Caption', 'DOCX') }
                ],
            }
        },
        props: {
            listTitle: {
                type: [String],
                required: false,
                default: ""
            },
            filterTitle: {
                type: [String],
                required: false,
                default: ""
            },
            ttyId: {
                type: [Number],
                required: false,
                default: 0
            },
            statusId: {
                type: [Number],
                required: false,
                default: 0
            },
            filterTltId: {
                type: [Number],
                required: false,
                default: 0
            },
            filterTtyId: {
                type: [Number],
                required: false,
                default: 0
            },
            filterStgId: {
                type: [Number],
                required: false,
                default: 0
            },
            filterStatusId: {
                type: [Number],
                required: false,
                default: 0
            },
            onlyPublishedInFilter: {
                type: [Boolean],
                required: false,
                default: false
            },
            useFullTextSearch: {
                type: [Boolean],
                required: false,
                default: false
            },
            onlyAssignedTopics: {
                type: [Boolean],
                required: false,
                default: false
            },
            onlyOwnedTopics: {
                type: [Boolean],
                required: false,
                default: false
            },
            worId: {
                type: [Number],
                required: false,
                default: 0
            },
            rouId: {
                type: [Number],
                required: false,
                default: 0
            },
            stgId: {
                type: [Number],
                required: false,
                default: 0
            },
            excludeStgId: {
                type: [Number],
                required: false,
                default: 0
            },
            columns: {
                required: false,
                default: []
            },
            columnsConfig: {
                required: false,
                default: []
            },
            hiddenColumns: {
                required: false,
                default: []
            },
            showBookmarkFilter: {
                type: [Boolean],
                required: false,
                default: false
            },
            showRoundFilter: {
                type: [Boolean],
                required: false,
                default: false
            },
            showProfileButton: {
                type: [Boolean],
                required: false,
                default: false
            },
            showAddNew: {
                type: [Boolean],
                required: false,
                default: false
            },
            showExpertsModeSwitch: {
                type: [Boolean],
                required: false,
                default: false
            },
            showOwnerStatus: {
                type: [Boolean],
                required: false,
                default: false
            },
            showStatusFilter: {
                type: [Boolean],
                required: false,
                default: false
            },
            filters: {
                required: false,
                default: []
            },
        },
        computed: {
            gridColumns: function () {
                var cols = [

                    {
                        pos: -10, id: "actionColumn", name: "actionColumn", sysCol: true, caption: '', cellTemplate: 'actionTemplate', dataType: "string", dataField: 'TopicId',
                        cssClass: "actionColumn", width: this.actionColumnWidth, maxWidth: this.actionColumnWidth, minWidth: this.actionColumnWidth,
                        allowFiltering: false, allowHeaderFiltering: false, allowResizing: false, allowColumnReordering: false, fixed: true,
                        alignment: "center", showInColumnChooser: false, allowSearch: false
                    },

                    {
                        pos: -9, id: "commentColumn", sysCol: true, caption: '', dataType: "number", dataField: 'CommentsCount', cellTemplate: 'commentTemplate'
                        , width: 50, visible: this.accessList._300511, cssClass: "commentColumn", allowFiltering: false, allowHeaderFiltering: true, allowSearch: true,
                        allowResizing: false, allowColumnReordering: false, fixed: true, showInColumnChooser: false
                    },

                    {
                        pos: -8, id: "flagColumn", sysCol: true, caption: 'Flags', width: 60, cellTemplate: 'flagTemplate', dataType: "number", dataField: 'Flag', cssClass: "flagColumn"
                        , allowFiltering: false, allowHeaderFiltering: true, allowSearch: true,
                        allowResizing: false, allowColumnReordering: false, fixed: true, visible: this.accessList._300561, alignment: "center", showInColumnChooser: true
                    },
                    {
                        pos: -7, id: "TopicId", name: "TopicId", sysCol: true, caption: 'ID', dataType: "number", dataField: 'TopicId', allowSearch: false, cssClass: "colKey", width: 100, visible: true
                    },
                    { pos: -6, id: "title", sysCol: true, caption: this.col.TitleCol, dataType: 'string', dataField: 'Title', cssClass: "colKey", configure: true },
                    { id: "TpcDescription", caption: this.col.DescCol, dataType: 'string', dataField: 'TpcDescription', cssClass: "colKey", width: 200, visible: true, configure: true },



                    { id: "TdgLisId001", dataType: "number", dataField: "TdgLisId001", width: 170, configure: true },
                    { id: "TdgLisId002", dataType: "number", dataField: "TdgLisId002", width: 170, configure: true },
                    { id: "TdgMemo001", dataType: "string", dataField: "TdgMemo001", width: 170, configure: true },
                    { id: "TdgMultiSelect001", dataType: "string", dataField: "TdgMultiSelect001", width: 170, configure: true },
                    { id: "TdgMultiSelect002", dataType: "string", dataField: "TdgMultiSelect002", width: 170, configure: true },
                    { id: "TdgMultiSelect003", dataType: "string", dataField: "TdgMultiSelect003", width: 170, configure: true },
                    { id: "TdgText001", dataType: "string", dataField: "TdgText001", width: 170, configure: true },
                    { id: "TdgText002", dataType: "string", dataField: "TdgText002", width: 170, configure: true },
                    { id: "TdgText003", dataType: "string", dataField: "TdgText003", width: 170, configure: true },
                    { id: "TdgText004", dataType: "string", dataField: "TdgText004", width: 170, configure: true },
                    { id: "TpcBegin", dataType: "date", dataField: "TpcBegin", caption: "Start", width: 170, configure: true },
                    { id: "TpcEnd", dataType: "date", dataField: "TpcEnd", caption: "Ende", width: 170, configure: true },

                    { id: "TdgDate001", caption: this.col.EndofStudyCol, cellTemplate: 'EndofStudyTemplate', dataType: 'date', allowSearch: false, dataField: 'TdgDate001', width: 130 },
                    { id: "PublishDate", caption: this.col.PublishDateCol, dataType: 'string', dataField: 'PublishDate', width: 100, visible: false },

                    { id: "Relevant", caption: this.col.RelevantCol, dataType: "number", allowSearch: false, dataField: 'Rank', showInColumnChooser: false, visible: false, width: 100 },


                    { pos: 100010, id: "Assignee", sysCol: true, caption: this.col.AssigneeCol, dataType: 'string', dataField: 'Assignee', width: 100 },
                    { pos: 100020, id: "Owner", sysCol: true, caption: this.col.OwnerCol, dataType: 'string', dataField: 'Scout', width: 100 },
                    { pos: 100030, id: "StatusName", sysCol: true, caption: this.col.StatusCol, dataType: 'string', dataField: 'StatusName', width: 100 },
                    {
                        pos: 100040, id: "TopicStatusAction", sysCol: true, caption: this.col.StatusActionCol, minWidth: 80, cellTemplate: 'topicStatusActionTemplate', cssClass: "topicLinkActionColumn",
                        allowFiltering: false, allowHeaderFiltering: false, allowResizing: true, allowColumnReordering: false,
                        alignment: "left", showInColumnChooser: true, allowSearch: false
                    },

                    {
                        pos: 100050, id: "LinkedTopicStatus", sysCol: true, caption: this.col.LinkedtopicStatusCol, dataType: 'string', dataField: 'TopicLinkStatus', width: 100, visible: this.isFilterVisible
                    },
                    {
                        pos: 100060, id: "TopicLinkStatusAction", sysCol: true, caption: this.col.LinkedtopicStatusActionCol, minWidth: 80, cellTemplate: 'topicLinkStatusActionTemplate', cssClass: "topicLinkActionColumn",
                        allowFiltering: false, allowHeaderFiltering: false, allowResizing: true, allowColumnReordering: false,
                        alignment: "left", showInColumnChooser: false, allowSearch: false, visible: this.isFilterVisiible
                    },

                    { pos: 100070, id: "TpcFullfillmentPercent", sysCol: true, caption: this.col.TpcFullfillmentPercentCol, dataType: 'number', cellTemplate: "percentTemplate", dataField: 'TpcFullfillmentPercent', width: 100 },

                    { pos: 100080, id: "CreatedOn", sysCol: true, caption: this.col.CreatedOnCol, dataType: 'date', allowSearch: false, dataField: 'CreatedOn', width: 130, visible: false },
                    { pos: 100090, id: "CreatedBy", sysCol: true, caption: this.col.CreatedByCol, dataType: 'string', dataField: 'CreatedBy', visible: this.isCreatedByVisible, width: 100 },
                    { pos: 100100, id: "ChangedOn", sysCol: true, caption: this.col.ChangedOnCol, dataType: 'date', allowSearch: false, dataField: 'ChangedOn', visible: this.isChangedOnVisible, width: 100 },
                    { pos: 100110, id: "ChangedBy", sysCol: true, caption: this.col.ChangedByCol, dataType: 'string', dataField: 'ChangedBy', visible: this.isChangedByVisible, width: 100 },
                ];

                //debugger;

                if (!this.columnList || this.columnList.length == 0) {
                    //return []
                    return cols;
                }


                this.columnList.forEach(m => {
                    var col = cols.find(c => c.dataField && m.dataField && c.dataField == m.dataField)
                    if (!col) {
                        col = { id: m.dataField, dataType: 'string', dataField: m.dataField, caption: m.caption, width: 100, visible: m.visible, configure: true };
                        cols.push(col);
                    }
                    else {
                        col.caption = m.caption;
                    }
                });
                cols.forEach(m => {
                    var col = this.columnList.find(c => c.dataField && m.dataField && c.dataField.toLowerCase() == m.dataField.toLowerCase())
                    if (!col && !m.sysCol) {
                        m.remove = true
                    }
                    else if (m.sysCol) {
                        var sysCol = this.columns.find(c => c && m.id && c.toLowerCase() == m.id.toLowerCase())
                        if (!sysCol) {
                            m.remove = true
                        }
                    }
                });

                var result = cols.filter(m => !m.remove)



                result.forEach(c => {
                    if (c.configure) {
                        var item = this.columnList.find(m => m.dataField && c.dataField
                            && m.dataField.toLowerCase() == c.dataField.toLowerCase())
                        if (item) {
                            c.caption = item.caption
                            c.visible = item.visible
                            c.pos = item.position
                        }
                    }
                    if (this.hiddenColumns.includes(c.id)) {
                        c.visible = false
                    }
                })
                if (this.columnsConfig) {
                    this.columnsConfig.forEach(c => {
                        var i = result.findIndex(m => m.id.toLowerCase() == c.id.toLowerCase())
                        if (i >= 0) {
                            result[i] = { ...result[i], ...c };
                        }
                    })
                }
                var colResult = result.sort((a, b) => (a.pos > b.pos ? 1 : -1));
                return colResult;
            },
            actionColumnWidth() {
                return 80; // 80 + (this.showProfileButton ? 40 : 0)
            },
            showTopicFilter: function () {
                return this.filterTtyId > 0 && this.filterTltId > 0;
            },
            ListTitle: function () {
                return (this.listTitle > '') ? this.listTitle : (this.selectedTty ? this.selectedTty.TtyShortName : this.tx.TopicListCaption);
            },
            isFilterVisiible: function () {
                return this.selectedFilter
            },
            topicTypeAccess: function () {
                return this.$store.state.topicStore.topicTypeAccess;
            },
            isTitleVisible: function () {
                return this.ttyId != 22
            },
            filterKey: function () {
                return window.location.pathname;
            },
            storageKey: function () {
                return this.gridKey + "Storage_" + this.ttyId + "_" + this.rouId;
            },
            selectedTtyId: {
                get: function () {
                    return this.selectedTty ? this.selectedTty.TtyId : (this.ttyId > 0 ? this.ttyId : null);
                },
                set: function (newValue) {
                    this.selectedTty = this.topicTypeList.find(m => m.TtyId == newValue)
                }
            },
            showTtySelection: function () {
                return this.ttyId == 0;
            },
            grid: function () {
                const ref = this.$refs[this.gridKey]
                if (ref) {
                    return ref.instance
                }
                return null
            },

            selectionMode() {
                return this.expertMode && this.access.allowChangeState || this.access.allowCart || this.access.allowTopicLink || this.accessList._300421 ? "multiple" : "none"
            },
            hasSelection() {
                return this.selectedRowKeys && this.selectedRowKeys.length > 0
            },
            readAccessClasses() {
                if (this.access) {
                    var result = [];
                    if (this.access.allowRead) {
                        result.push("frm-read")
                    }
                    if (this.access.allowUpdate) {
                        result.push("frm-edit")
                    }
                    return result.join(" ");
                }
                return "";
            },
            access() {
                return this.$store.state.topicStore.access;
            },
            toolbar() {
                return this.$store.state.toolbarStore.icons;
            },
            topicList() {
                var timeElapsed = Date.now();
                var today = new Date(timeElapsed);
                let dateToday = new Date(today).getTime();

                var result = this.$store.state.topicStore.topicList
                result.sort((a, b) => (a.TtyOrder > b.TtyOrder ? 1 : -1))
                result.forEach((element, index) => {
                    if ((dateToday <= new Date(element.TdgDate001).getTime()) || !element.TdgDate001) {
                        result[index].Expired = false;
                    }
                    else
                        result[index].Expired = true;
                });

                result = result.filter(t => t.StatusId != this.filterStatusId);
                return result
            },
            commentList() {
                var result = this.$store.state.commentStore.commentList
                return result
            },
            columnList() {
                var result = this.$store.state.topicStore.columnList
                return result
            },

            topicTypeList() {
                var result = this.$store.state.topicTypeStore.ttySimpleList
                return result
            },
            cartList() {
                var result = this.$store.state.cartStore.myCartsAndPublicList
                return result
            },
            filterTopicList() {
                var result = this.$store.state.topicStore.topicsByTypeAndStgIdList
                return result
            },
            fullStatusList() {
                var result = this.$store.state.statusStore.statusListSimple
                return result
            },
            statusList() {
                var worId = this.selectedTty ? this.selectedTty.WorId : 0
                return [null].concat(this.fullStatusList.filter(m => m.WorId == worId))
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
            userListForGroup() {
                return this.$store.state.userStore.userListForGroup
            },
            userListForCreate() {
                return this.$store.state.userStore.userListForCreate
            },
            newStatusList() {
                return this.statusList.filter(m => m && m.StatusID != this.selectedStatusId)
            },
            roundList() {
                return this.$store.state.roundStore.openRoundList
            },
            currentUsrId() {
                return this.$store.state.topicStore.currentUsrId
            },
            quickHelp() {
                return this.$store.state.helpStore.quickHelp
            },
            pageTitle() {
                var qh = this.$store.state.helpStore.quickHelp;
                return qh && qh.Title > '' ? qh.Title : this.listTitle
            },
            quickHelpHasEntry() {
                var qh = this.$store.state.helpStore.quickHelp;
                return qh && qh.HasEntry
            },
            pageDescription() {
                var qh = this.$store.state.helpStore.quickHelp;
                return qh && qh.Text > '' && qh.HasEntry ? qh.Text : ""
            },
            selectedCartName() {
                return this.selectedCrt ? this.selectedCrt.CrtName : ""
            },
            selectedTopicTitle() {
                return this.selectedFilter ? this.selectedFilter.ParsedTitle : ""
            },

            filterState: {
                cache: false,
                set: function (val) {
                    const filter = JSON.stringify(val);
                    if (this.currentFilter != filter) {
                        sessionStorage.setItem(this.filterKey, filter);
                        this.filterStateInternal = val
                    }
                },
                get: function () {
                    return this.filterStateInternal
                }
            },
            loaded() {
                return this.topicTypeList && this.topicTypeList.length > 0 &&
                    this.roundList && this.roundList.length > 0
            },
        },
        watch: {
            topicTypeList: function (newVal) {
                if (newVal && newVal.length > 0 && this.filterState) {
                    this.selectedTtyId = this.filterState.selectedTtyId
                }
            },
            access: function () {
                this.filterList[2].visible = this.access.allowUpdate;
            },
            statusList: function (newVal) {
                if (newVal && newVal.length > 0 && this.filterState) {
                    this.selectedStatusId = this.filterState.selectedStatusId
                }
            },
            cartList: function (newVal) {
                if (newVal && newVal.length > 0 && this.filterState && this.filterState.selectedCrt && this.filterState.selectedCrt.CrtId > 0) {
                    this.selectedCrt = this.cartList.find(m => m.CrtId == this.filterState.selectedCrt.CrtId)
                }
            },
            filterTopicList: function (newVal) {
                if (newVal && newVal.length > 0 && this.filterState && this.filterState.selectedFilter && this.filterState.selectedFilter.TopicId > 0) {
                    this.selectedFilter = this.filterTopicList.find(m => m.TopicId == this.filterState.selectedFilter.TopicId)
                }
            },
            selectedTtyId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.selectedStatusId = null
                    this.loadData()
                }
            },
            searchText: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    if (this.filterState.searchText != newVal) {
                        this.filterState.searchText = newVal
                    }
                }
            },
            selectedStatusId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            },
            expertMode: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                    if (!newVal) {
                        this.isRankVisible = false
                        this.isDescriptionVisible = false
                    }
                    else {
                        this.isDescriptionVisible = true
                        this.isRankVisible = true
                    }
                }
            },
            selectedRouId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            },
            selectedCrt: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            },
            selectedFilter: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            },
            topicList: function (newVal, oldVal) {
                if (newVal != oldVal && this.grid != null)
                    this.grid.pageIndex(this.pageIndex)
            },
            filterValue: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            },
            //allowEditRow: function (newVal, oldVal) {
            //    if (newVal != oldVal) {
            //        this.loadData()
            //    }
            //},
            loaded: function (newVal, oldVal) {
                if (!this.isLoaded && newVal && !oldVal) {
                    this.isLoaded = true
                    this.loadData()
                }
            },

        },
        created: function () {
            this.loading = true
            this.moment = moment
            Promise.all([
                this.$store.dispatch("getTtySimpleList", {}),
                this.$store.dispatch("getQuickHelp", { pageTitle: this.listTitle }),
                this.$store.dispatch("getTopicTypeAccess", { ttyId: this.ttyId }),
                this.$store.dispatch("getOpenRoundList", {}),
                this.$store.dispatch("getStatusListSimple", { worId: this.worId }),
                this.$store.dispatch("getMyCartsAndPublic", {}),
                //this.$store.dispatch("getMfgList", {}),
                this.$store.dispatch("getTopicsByTypeAndStgId", { ttyId: this.filterTtyId, stgId: this.filterStgId }),
                this.$store.dispatch("getAccessList", { tokenList: ["300231", "300511", "300514", "300518", "200221", "300561", "300681", "300688", "200721", "200781"] })
            ]).then(() => {
                this.loading = false
            })
            const filter = sessionStorage.getItem(this.filterKey)
            this.filterState = filter > '' ? JSON.parse(filter) : null
            var filterState = this.filterState
            if (filterState) {
                this.searchText = filterState.searchText ? filterState.searchText : ""
                this.filterValue = this.filterList.find(m => { return filterState.filterValue == m.id })
                this.selectedRouId = filterState.selectedRouId
                this.expertMode = filterState.expertMode
            }
            else {
                this.filterValue = this.filterList[0]
            }
        },
        methods: {
            SplitMulti(data) {
                var result = "";
                if (data.value) {
                    var arr = data.value.split(",")
                    result = "<ul><li>" + arr.join("</li><li>") + "</li></ul>";
                }
                return result;
            },
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            onCellPrepared(e) {
                var timeElapsed = Date.now();
                var today = new Date(timeElapsed);
                let dateToday = new Date(today).getTime();

                if (e.rowType === "data") {
                    if (e.column.dataField == "TdgDate001") {
                        if ((dateToday >= new Date(e.value).getTime()) && e.value) {
                            e.cellElement.classList.add("expiredStudy");
                        }
                    }
                }
            },
            statusChanged: function () {
                this.loadData(true);
            },
            statusTopicLinkChanged: function () {
                this.loadData(true);
            },
            acceptDelete: function (message) {
                this.$store.dispatch("deleteComment", { CmId: message.ComId })
                this.$store.dispatch("getCommentsForTopic", { TopicId: message.TopicId, CtyId: 2 })

            },
            log: function () {
                // Debug logging removed for production
            },
            changeTopicStatus: function (topicId, statusId) {
                const popup = this.$refs.changeTopicStatusPopup;
                popup.showTopicPopup(topicId, statusId)
            },
            changeTopicLinkStatus: function (topicId, tliId, statusId) {
                const popup = this.$refs.changeTopicStatusPopup;
                popup.showTopicLinkPopup(topicId, tliId, statusId)
            },
            sendBulkMail: function () {
                this.loading = true
                nextTick(() => {
                    var msg = this.$refs.bulkMailEditor.instance._getContent()[0].innerHTML
                    var args = JSON.stringify({
                        IdList: this.selectedRowKeys,
                        MailBody: msg,
                        MailSubject: this.bulkMessage.Subject
                    })
                    this.$store.dispatch("sendBulkMail", args).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.isToastVisible = true
                            this.toastMessage = "Mail sent successfully"
                        }
                        else {
                            alert("Error on Sending Mail", "Error").then(() => {
                                this.popupVisible = false;
                            })
                        }
                    })
                    this.resetSelection()
                })
                this.popupVisible = false;
            },
            onEditorPreparing: function (e) {
                if (this.useFullTextSearch) {
                    if (e.parentType === "searchPanel") {
                        e.updateValueTimeout = 1000;
                        e.editorOptions.onValueChanged = (e) => this.onSearch(e);
                        this.searchText = ""
                        //e.editorOptions.value = this.searchText
                        //e.editorOptions.valueChangeEvent = "change search";
                    }
                }
            },
            onSearch(e) {
                this.onSearchAction(function () {
                    this.searchText = e.value
                    if (this.filterState.searchText != this.searchText) {
                        this.filterState.searchText = this.searchText
                        this.loadData()
                    }
                }.bind(this))
            },
            onSearchAction(action) {
                this.actionBuffer.forEach((e) => { e.action = function () { } })
                this.actionBuffer.push(action)
                setTimeout(() => {
                    var nr = this.actionBuffer.length
                    this.actionBuffer[nr - 1]()
                }, 2000)

            },
            viewDetail(e) {
                if (e.column.cssClass === "colKey") {
                    window.LoadPanel.Show()
                    this.viewRowTopicVx(e.data)
                    return
                }
            },
            getFilterList() {
                var filterList = [{ id: 0, text: this.$LanguageProvider.GetResource("All", "CaptionFilter", "All") },
                { id: 1, text: this.$LanguageProvider.GetResource("MyBookMark", "Caption", "Created by Me"), visible: this.access.allowUpdate },
                { id: 2, text: this.$LanguageProvider.GetResource("AssignedToMe", "Caption", "Assigned to Me") },
                ]
                return filterList;
            },
            getRowMenuItems(data) {
                var result = [{
                    id: 1,
                    topic: data.data,
                    text: '',
                    icon: 'pqMenuElipsis fas fa-ellipsis-v',
                    visible: data.data.AllowEdit,
                    items: [{ text: 'Lesen', id: 'view', icon: "ca-read far fas fa-eye", visible: true },
                    { text: 'Bearbeiten', id: 'edit', icon: "fas fa-pen", visible: data.data.AllowEdit }]
                }]
                this.allowEditRow = data.data.AllowEdit;
                return result
            },
            getFlagMenuItems(data) {
                var result = [{
                    id: -1,
                    topic: data.data,
                    text: '',
                    icon: 'flmArea fa fa-flag FlagMenuItem',
                    visible: true,
                    items: [
                        { text: ' ', id: 0, icon: "fa fa-flag FlagMenuItem-0" },
                        { text: '1', id: 1, icon: "fa fa-flag FlagMenuItem-1" },
                        { text: '2', id: 2, icon: "fa fa-flag FlagMenuItem-2" },
                        { text: '3', id: 3, icon: "fa fa-flag FlagMenuItem-3" },
                        { text: '4', id: 4, icon: "fa fa-flag FlagMenuItem-4" },
                        { text: '5', id: 5, icon: "fa fa-flag FlagMenuItem-5" },
                        { text: '6', id: 6, icon: "fa fa-flag FlagMenuItem-6" },
                    ]
                }]
                return result
            },
            resetFilter: function () {
                this.grid.clearFilter()
                this.filterValue = this.filterList[0]
                this.selectedRouId = null
                this.selectedTtyId = null
                this.selectedStatusId = null
                this.searchText = null
                this.selectedCrt = null
            },
            addToCart: function () {
                const cart = this.selectedCartForAction
                if (cart != null) {
                    this.$store.dispatch("addToCart", {
                        CrtId: cart.CrtId,
                        CrtName: cart.CrtName,
                        CrtFullName: cart.CrtFullName,
                        CrtPublic: cart.CrtPublic,
                        TopicList: this.selectedRowKeys
                    }).then(() => {
                        nextTick(() => {
                            this.CartBoxKey++
                        })
                    })
                    this.resetSelection()
                    this.popupVisible = false
                }
            },
            addToTopic: function () {
                const topic = this.selectedTopicForAction;

                if (topic != null) {
                    this.$store.dispatch("addToTopic", {
                        TopicId: topic.TopicId,
                        Title: topic.ParsedTitle,
                        SchalzeitId: topic.SchalzeitId,
                        FilterTltId: this.filterTltId,
                        TtyName: topic.TtyName,
                        TopicList: this.selectedRowKeys,
                        AddTopicLinkMode: this.addTopicLinkMode
                    }).then(() => {
                        this.$store.dispatch("getTopicsByTypeAndStgId", { ttyId: this.filterTtyId, stgId: this.filterStgId })
                        nextTick(() => {
                            this.filterBoxKey++
                        })
                    })
                    this.resetSelection()
                    this.popupVisible = false
                }
            },
            editCart: function () {
                const cart = this.selectedCrt
                if (cart != null) {
                    this.$store.dispatch("editCart", {
                        CrtId: cart.CrtId,
                        CrtName: cart.CrtName,
                        CrtFullName: cart.CrtFullName,
                        CrtPublic: cart.CrtPublic
                    }).then(() => {
                        nextTick(() => {
                            this.$store.dispatch("getMyCartsAndPublic", {})
                            this.CartBoxKey++
                        })
                    })
                    this.popupVisible = false
                }
            },
            deleteCart: function () {
                const cart = this.selectedCrt
                if (cart != null) {
                    this.$store.dispatch("deleteCart", {
                        CrtId: cart.CrtId,
                        CrtName: cart.CrtName,
                        CrtFullName: cart.CrtFullName,
                        CrtPublic: cart.CrtPublic
                    }).then(() => {
                        nextTick(() => {
                            this.CartBoxKey++
                            this.loadData(true)
                        })
                    })
                    this.popupVisible = false
                }
            },
            removeFromCart: function () {
                if (this.selectedCrt != null) {
                    this.$store.dispatch("removeFromCart", {
                        CrtId: this.selectedCrt.CrtId,
                        TopicList: this.selectedRowKeys
                    }).then(() => {
                        this.loadData(true)
                    })
                    this.popupVisible = false
                }
            },
            removeFromTopic: function () {
                if (this.selectedFilter != null) {
                    this.$store.dispatch("removeFromTopic", {
                        TopicId: this.selectedFilter.TopicId,
                        TopicList: this.selectedRowKeys,
                        TltId: this.filterTltId
                    }).then(() => {
                        this.loadData(true)
                    })
                    this.popupVisible = false
                }
            },
            resetState: function () {
                this.grid.state(null)
                this.clearSearch()
                this.resetFilter()
                this.loadData(true)
            },
            search: function () {
                if (!this.filterState.searchText != this.searchText) {
                    this.filterState.searchText = this.searchText
                    this.loadData()
                }
                this.searchVisible = false
            },
            clearSearch: function () {
                this.searchText = ""
            },
            searchChanged: function () {
                this.searchVisible = true
            },
            searchValueChanged: function (e) {
                if (e.value == "" && e.previousValue != "") {
                    this.loadData()
                    this.searchVisible = true
                }
            },
            createNewTopicForUser() {
                if (this.selectedUsrIdForAction > 0) {
                    this.loading = true
                    this.$store.dispatch("createTopic", { ttyId: this.ttyId, usrId: this.selectedUsrIdForAction }).then((res) => {
                        if (res.success) {
                            window.LoadPanel.Show()
                            this.grid.deselectAll().done(function () {
                                var data = { action: "edit", id: res.topicId, list: [res.topicId], args: this.args }
                                var url = window.location.pathname
                                window.post(url, data)
                            })
                        }
                        this.loading = false
                    })
                }
                else {
                    alert("Please select an auser from the list", "Create Application")
                }
            },
            addTopic: function () {
                this.loading = true
                this.$store.dispatch("getUserListForCreate", { ttyId: this.ttyId }).then((res1) => {
                    if (res1.success) {
                        if (res1.showUserSelection) {
                            this.popupTemplate = "createNewTopicForUser"
                            this.popupVisible = true
                            this.popupTitle = "Create Application"
                        }
                        else {
                            this.$store.dispatch("createTopic", { ttyId: this.ttyId }).then((res) => {
                                if (res.success) {
                                    window.LoadPanel.Show()
                                    this.grid.deselectAll().done(function () {
                                        var data = { action: "edit", id: res.topicId, list: [res.topicId] }
                                        var url = window.location.pathname
                                        window.post(url, data)
                                    })
                                }
                                this.loading = false
                            })
                        }
                    }
                    this.loading = false
                })
            },
            goToMyVoting: function () {
                window.LoadPanel.Show()
                window.location.href = window.location.pathname + "?action=myVoting"
            },
            loadData: function (force) {
                if (!this.loaded) {
                    return //Promise.resolve()
                }
                if (this.grid != null) {
                    // Grid is ready
                }
                this.filterState = {
                    selectedRouId: this.selectedRouId,
                    selectedTtyId: this.selectedTtyId,
                    filterTltId: this.filterTltId,
                    selectedStatusId: this.selectedStatusId,
                    selectedCrt: this.selectedCrt,
                    selectedFilterId: this.selectedFilterId,
                    expertMode: this.expertMode,
                    searchText: this.searchText,
                    filterValue: this.filterValue,
                }
                const filter = this.expertMode ? {
                    StgId: this.stgId,
                    ExcludeStgId: this.excludeStgId,
                    OnlyOwnedTopics: this.onlyOwnedTopics,
                    OnlyAssignedTopics: this.onlyAssignedTopics,
                    RouId: this.selectedRouId,
                    Filter: this.filterValue ? this.filterValue.id : 0,
                    TtyId: this.ttyId,
                    WorId: this.worId,
                    FilterTltId: this.filterTltId,
                    StatusId: this.selectedStatusId ? this.selectedStatusId : this.statusId,
                    Search: this.useFullTextSearch ? this.searchText : null,
                    CrtId: this.selectedCrt ? this.selectedCrt.CrtId : 0,
                    FilterTopicId: this.selectedFilter ? this.selectedFilter.TopicId : 0,
                    AddWorkflowInfos: 1
                } : {
                    OnlyOwnedTopics: this.onlyOwnedTopics,
                    OnlyAssignedTopics: this.onlyAssignedTopics,
                    TtyId: this.ttyId,
                    WorId: this.worId,
                    StgId: this.stgId,
                    ExcludeStgId: this.excludeStgId,
                    Search: this.useFullTextSearch ? this.searchText : null,
                    CrtId: this.selectedCrt ? this.selectedCrt.CrtId : 0,
                    Filter: this.filterValue ? this.filterValue.id : 0,
                }
                if (JSON.stringify(filter) != JSON.stringify(this.filter) || force == true) {
                    this.filter = filter
                    this.loading = true
                    return this.$store.dispatch("getTopicList", filter).then(() => {
                        this.loading = false
                    })
                }
                return //Promise.resolve()
            },
            viewTopicNr: function (id) {
                window.LoadPanel.Show()
                var rec = this.topicList.find(m => m.TopicId == id);
                this.viewTopic(rec.TopicId, "view");
            },
            viewProfileNr: function (id) {
                window.LoadPanel.Show()
                var rec = this.topicList.find(m => m.TopicId == id);
                this.viewTopic(rec.TopicId, "viewProfile");
            },
            viewTopic: function (topicId, action) {
                this.grid.selectAll().done(x => {
                    const topicList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        var data = { action, id: topicId, list: topicList }
                        var url = window.location.pathname
                        window.post(url, data)
                    })
                })
            },
            viewProfile: function (topicId) {
                this.grid.selectAll().done(x => {
                    const topicList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        var data = { action: "viewProfile", id: topicId, list: topicList }
                        var url = window.location.pathname
                        window.post(url, data)
                    })
                })
            },
            viewRowTopic: function (data) {
                window.LoadPanel.Show()
                var self = this;
                var rec = self.topicList.find(m => m.TopicId == data.TopicId);
                if (rec) {
                    this.grid.selectAll().done(x => {
                        const topicList = JSON.stringify(x.map(r => r.TopicId))
                        this.grid.deselectAll().done(function () {
                            var data = { action: "view", id: rec.TopicId, list: topicList }
                            var url = window.location.pathname
                            window.post(url, data)
                        })
                    })
                }
            },
            viewRowTopicVx: function (data) {
                window.LoadPanel.Show()
                var self = this;
                
                var rec = self.topicList.find(m => m.TopicId == data.TopicId);
                
                if (!rec) {
                    window.LoadPanel.Hide()
                    this.toastMessage = "Unable to access this topic. You may not have permission to view it."
                    this.isToastVisible = true
                    return
                }
                
                if (!this.grid) {
                    window.LoadPanel.Hide()
                    this.toastMessage = "Grid not ready. Please try again."
                    this.isToastVisible = true
                    return
                }
                
                // Check if window.post exists
                if (typeof window.post !== 'function') {
                    window.LoadPanel.Hide()
                    this.toastMessage = "Navigation function not available. Please refresh the page."
                    this.isToastVisible = true
                    return
                }
                
                // Add timeout to prevent infinite loading
                const timeoutId = setTimeout(() => {
                    window.LoadPanel.Hide()
                    this.toastMessage = "Operation timed out. Please try again."
                    this.isToastVisible = true
                }, 10000) // 10 second timeout
                
                this.grid.selectAll().done(x => {
                    clearTimeout(timeoutId)
                    const topicList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        var data = { action: "view", id: rec.TopicId, list: topicList }
                        var url = window.location.pathname
                        window.post(url, data)
                    }).fail(function() {
                        clearTimeout(timeoutId)
                        window.LoadPanel.Hide()
                        self.toastMessage = "An error occurred. Please try again."
                        self.isToastVisible = true
                    })
                }).fail(function() {
                    clearTimeout(timeoutId)
                    window.LoadPanel.Hide()
                    
                    try {
                        var fallbackData = { action: "view", id: rec.TopicId, list: JSON.stringify([rec.TopicId]) }
                        var url = window.location.pathname
                        window.post(url, fallbackData)
                    } catch (fallbackError) {
                        self.toastMessage = "Unable to open topic. Please contact support."
                        self.isToastVisible = true
                    }
                })
            },
            editTopic: function (data) {
                window.LoadPanel.Show()
                var rec = this.topicList.find(m => m.TopicId == data);
                if (rec) {
                    this.grid.selectAll().done(x => {
                        const topicList = JSON.stringify(x.map(r => r.TopicId))
                        this.grid.deselectAll().done(function () {
                            var data = { action: "edit", id: rec.TopicId, list: topicList }
                            var url = window.location.pathname
                            window.post(url, data)
                        })
                    })
                }
            },
            loadStateX() {
                return axios.get(gridServiceUri + '/GetState', { params: { ControlName: "TopicOverview.vue", ViewName: "GrdMain" } })
                    .then(res => {
                        return res.data.Data
                    })
            },
            saveStateX(state) {
                var formData = new FormData()
                formData.append("ControlName", "TopicOverview.vue")
                formData.append("ViewName", "GrdMain")
                formData.append("State", JSON.stringify(state))
                axios.post(gridServiceUri + '/SaveState', formData).then(res => {
                    if (res.data.Success == false) {
                        alert("Fehler")
                    }
                })
            },
            loadState() {
                const stateTxt = sessionStorage.getItem(this.storageKey)
                if (stateTxt && stateTxt > '') {
                    var state = JSON.parse(stateTxt);
                    state.columns = state.columns.filter(m => {
                        return this.columnList.indexOf(u => {
                            return u.dataField == m.dataField
                        })
                    })
                    state.columns = state.columns.filter(m => !m.fixed)
                    this.pageIndex = state.pageIndex
                    return state
                }
                else {
                    return null
                }
            },
            saveState(state) {
                if (state) {
                    for (let i = 0; i < state.columns.length; i++) {
                        state.columns[i].filterValue = null;
                    }
                }
                sessionStorage.setItem(this.storageKey, JSON.stringify(state));
            },
            menuItemClick(e, id) {
                switch (e.itemData.id) {
                    case "edit":
                        window.LoadPanel.Show()
                        this.editTopic(id)
                        return
                    case "view":
                        window.LoadPanel.Show()
                        this.viewTopicNr(id)
                        return
                }
            },
            flagItemClick(e, data) {
                if (e.itemData.id >= 0) {
                    data.component.selectRows(data.key)
                    this.$store.dispatch("setTopicFlag", { FlagNr: e.itemData.id, Id: data.data.TopicId })
                        .then(() => {
                            data.value = e.itemData.id
                            data.component.selectRows()
                        });
                }
            },

            onSelectionChanged({ selectedRowKeys }) {
                this.selectedRowKeys = selectedRowKeys
            },

            showChangeState() {
                this.popupTemplate = "changeStatus"
                this.popupTitle = this.$LanguageProvider.GetResource("ChangeStatePopup", "Title", "Change State")
                this.popupVisible = true
            },
            hidePopup() {
                this.popupVisible = false
            },
            changeState() {
                if (this.newStatusId > 0 && this.selectedRowKeys && this.selectedRowKeys.length > 0) {
                    var args = JSON.stringify({ IdList: this.selectedRowKeys, StatusId: this.newStatusId })
                    this.$store.dispatch("bulkChangeStatus", args)
                    this.popupVisible = false
                    this.resetSelection()
                }
            },
            showAddToCart() {
                this.popupTemplate = "addToCart"
                this.popupTitle = this.$LanguageProvider.GetResource("AddToBookMarkPopup", "Caption", "Add to Bookmark List")
                this.popupVisible = true
            },
            showAddToTopic() {
                this.popupTemplate = "addToTopic"
                this.popupTitle = this.$LanguageProvider.GetResource("addToTopicPopup", "Caption", "Add to " + this.filterTitle)
                this.popupVisible = true
            },
            showBulkDownload() {
                this.popupTemplate = "bulkDownload"
                this.popupTitle = this.$LanguageProvider.GetResource("bulkDownload", "Caption", "Bulk Download")
                this.popupVisible = true
            },
            downloadPDFs() {
                var keys = encodeURIComponent(JSON.stringify(this.selectedRowKeys))
                const ext = this.downloadFormat === 'docx' ? 'docx' : 'pdf'
                const isSingle = this.selectedRowKeys && this.selectedRowKeys.length === 1
                const formatParam = (isSingle ? 'individual' : 'zip') + ext
                var arg = "?keys=" + keys + "&format=" + encodeURIComponent(formatParam);
                window.open("BulkDownloadPDF.aspx" + arg, "_blank");
                this.popupVisible = false
            },
            showSendBulkMail() {
                this.popupTemplate = "bulkMail"
                this.popupTitle = this.$LanguageProvider.GetResource("addToTopicPopup", "Caption", "Send Bulk Mail")
                this.popupVisible = true
            },
            showRemoveFromCart() {
                this.popupTemplate = "removeFromCart"
                this.popupTitle = this.$LanguageProvider.GetResource("RemoveFromBookMarkPopup", "Caption", "Remove from Bookmark List")
                this.popupVisible = true
            },
            showRemoveFromTopic() {
                this.popupTemplate = "removeFromTopic"
                this.popupTitle = this.$LanguageProvider.GetResource("removeFromTopicPopup", "Caption", "Remove from " + this.filterTitle)
                this.popupVisible = true
            },
            showEditCart() {
                this.popupTemplate = "editCart"
                this.popupTitle = this.$LanguageProvider.GetResource("EditBookmarkPopup", "Caption", "Edit Bookmark List")
                this.popupVisible = true
            },
            hideAddCart() {
                this.popupVisible = false
            },
            addingCart(e) {
                e.customItem = { CrtId: 0, CrtName: e.text, CrtFullName: e.text }
                this.cartList.push(e.customItem)
            },
            addingLinkedTopic(e) {
                e.customItem = { TopicId: 0, ParsedTitle: e.text }
                this.filterList.push(e.customItem)
            },
            resetSelection() {
                if (this.grid) {
                    this.grid.clearSelection()
                }
            },
            markCommentAsRead() {
                this.$store.dispatch("setCommentAsRead", { TopicId: this.currentTopic.TopicId }).then(() => {
                    this.currentTopic.CommentsUnreadCount = 0
                })
                this.popupVisible = false
            },
            showComments(data) {
                this.currentTopic = data.data
                this.$store.dispatch("getCommentsForTopic", { TopicId: data.data.TopicId, CtyId: 2 }).then(() => {
                    if (this.currentTopic.CommentsCount > 0) {
                        this.popupTemplate = "comments"
                        this.popupTitle = this.$LanguageProvider.GetResource("PopupTitleKommentar", "Caption", "Comments")
                        this.popupVisible = true
                    }
                    else {
                        this.createNewComment()
                    }
                })
            },
            saveComment() {
                this.$store.dispatch("saveTopicComment", { TopicId: this.currentTopic.TopicId, Comment: this.commentText, CtyId: 2 }).then(() => {
                    this.commentText = ""
                    if (!this.currentTopic.CommentsCount) {
                        this.currentTopic.CommentsCount = 0
                    }
                    this.currentTopic.CommentsCount++

                    if (!this.currentTopic.CommentsOwnCount) {
                        this.currentTopic.CommentsOwnCount = 0
                    }
                    this.currentTopic.CommentsOwnCount++
                })
                this.popupVisible = false
            },
            createNewComment() {
                this.popupTemplate = "newComment"
                this.popupTitle = this.$LanguageProvider.GetResource("CreateCm", "Caption", "Create Comment")
                this.popupVisible = true
            },
        }
    }
</script>
<style scoped>
    .puBoxScroll {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    }

    .pqMenuBtn {
        display: inline-flex;
        column-gap: 7px;
    }

    #app li {
        margin-left: unset;
    }

    .subhead {
        padding-bottom: 20px;
        font-size: var(--page-description-text-size);
        max-width: 800px;
    }

    .subHeadDes {
        padding-bottom: 5px;
        font-size: var(--page-description-subhead-size);
        font-weight: bold;
    }

    .mni-read, .mni-edit {
        display: none;
    }

    .frm-read .mni-view {
        display: block;
    }

    .frm-edit .mni-edit {
        display: block;
    }

    .na-FilterCell {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .na-Filter {
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    form .dx-loadpanel-content-wrapper * {
        display: none;
    }

    .cisVue {
        margin-right: 10px;
    }

    .mnExport div {
        border-radius: 5px;
        height: 29px;
    }

        .mnExport div i:before {
            color: white;
        }

    .pqMenu .dx-menu-item-popout-container {
        display: none !important;
    }

    #app .pqMenu li {
        margin-left: -4px;
    }

    .fullTextFilterBox {
        display: grid;
        grid-template-columns: 1fr 0;
    }

        .fullTextFilterBox .na-search-icon {
            position: relative;
            left: -26px;
            background: white;
            height: 20px;
            width: 20px;
            top: 2px;
        }

            .fullTextFilterBox .na-search-icon i {
                color: gray;
            }

    .puCell {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        padding-bottom: 25px;
        gap: 20px;
    }

    .puSubject.puCell {
        grid-template-columns: auto;
    }

    .puButtons {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }

    .puRightButtons {
        display: flex;
        gap: 10px;
    }

    .puFooterButtons {
        display: flex;
        gap: 10px;
        padding-top: 20px;
    }

    .naHeader {
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
    }

    .naTopControls {
        display: flex;
        justify-content: right;
        gap: 20px;
    }

    .grdCommentBox {
        display: grid;
        grid-template-columns: 15px 5px;
        cursor: pointer;
    }

    .grdCommentUnreadCount {
        margin-top: -5px;
        font-size: 10px;
        color: white;
        background: red;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 6px;
        line-height: 13px;
    }

    .grdCommentCount {
        font-size: 10px;
        margin-top: -6px;
    }

    .grdCommentIcon {
        font-size: 19px;
    }

    .cmtBox {
        display: grid;
        grid-template-columns: auto;
        width: 800px;
        max-height: 300px;
        /*overflow-y: scroll;*/
        margin-bottom: 10px;
    }

    .cmtTextBox .dx-texteditor-container {
        width: 100%;
        height: 300px;
    }

    .cmtHeader {
        font-weight: bold;
        display: flex;
        margin-bottom: 2px;
        gap: 2px;
        align-items: center;
    }

    .flmArea {
        position: relative;
        top: -24px;
        left: -18px;
        visibility: hidden;
    }

    i.fa.fa-flag {
        font-size: 19px;
    }

    .flgBox {
        height: 35px;
    }

    .flgBoxMenu {
        margin-top: -20px;
    }

    a.pqEmail {
        text-decoration: none;
        color: var(--m02-color-1);
    }

    .pqStatusActionList {
        display: flex;
        gap: 10px;
        color: var(--m02-color-1);
        text-decoration: underline;
        cursor: pointer;
    }

    table tr.dx-row td.topicLinkActionColumn {
        padding: 0 8px 0 8px !important;
    }
</style>
<style>
    .naGrid .flgBox .dx-menu-horizontal {
        position: relative;
        top: -15px;
        left: -19px;
        background: transparent;
    }

    .naGrid .dx-datagrid tr td.actionColumn {
        padding-left: 0;
    }


    .flgBoxMenu .pq-menu-item {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: self-end;
    }

    .colKey:hover {
        cursor: pointer;
        text-decoration: underline;
    }

    .puChangeStateButtons {
        display: flex;
        place-content: center;
        column-gap: 10%;
        padding-top: 20px;
    }

    .puChangeMessage {
        padding-top: 20px;
    }

    .pqMenuBtn {
        overflow: hidden;
    }

    .assigneeSelectionLabel {
        padding: 10px 0;
    }

    .puChangeStateMailTitle {
        padding: 0 0 10px;
    }


    .expiredStudy {
        background-color: lightsalmon !important;
    }

    .endOfStudy {
        height: 63px;
        padding-top: 21px;
        text-align: center;
    }

    td:has(div.endOfStudy) {
        padding-bottom: 0px !important;
        padding-top: 0px !important;
    }

    .mfgButton.mfgBackButton .dx-button-content {
        color: white;
    }


    .mfgButton.mfgBackButton .dx-button-mode-text.dx-button-default .dx-icon {
        color: white;
    }

    .pq-multi.dx-template-wrapper ul {
        margin: 0;
        padding: 0;
    }
</style>